import { Component, OnInit, Inject } from '@angular/core';
import { ExtratoEstoqueService } from 'src/app/services/clique-retire/extrato-estoque/extrato-estoque.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { FiltroExtratoEstoqueDetalhe, SelecionarExtratoEstoqueDetalhe } from 'src/app/@shared/models/extrato-estoque.model';
import { CabecalhoFixo, CABECALHO, Produto, PRODUTO } from 'src/app/@shared/models/dados-fixos';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-modal-extrato-estoque',
  templateUrl: './modal-extrato-estoque.component.html',
  styleUrls: ['./modal-extrato-estoque.component.scss']
})

export class ModalExtratoEstoqueComponent implements OnInit {
  isLoading = true;
  paging = { index: 0, size: 5, length: 0 };
  isTableLoading = true;
  dataExtrato: Date;
  extratoDetalhes: CabecalhoFixo; // MUDAR AQUI
  produto: Produto; // MUDAR AQUI
  extratos: MatTableDataSource<SelecionarExtratoEstoqueDetalhe> = new MatTableDataSource<SelecionarExtratoEstoqueDetalhe>();
  displayedColumns: string[] = [
    'status',
    'data',
    'modelo',
    'sequencia',
    'codigoBarra',
    'usuario',
    'origem'
  ];
  filtroExtrato: FiltroExtratoEstoqueDetalhe;

  constructor(
    public extratoEstoqueService: ExtratoEstoqueService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) {
    if (data && (data !== null && data !== undefined)) {
      this.dataExtrato = data;
      this.extratoDetalhes = CABECALHO;
      this.produto = PRODUTO;
      this.selecionarExtratoEstoqueDetalhe('2');
    }
  }

  ngOnInit() { }

  selecionarExtratoEstoqueDetalhe(status?: string, devolucao?: boolean) {
    //this.isTableLoading = true;

    this.filtroExtrato = {
      data: this.dataExtrato,
      status,
      devolucao,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size
    };

    this.extratoEstoqueService.selecionarExtratoEstoqueDetalhe(this.filtroExtrato)
      .subscribe(
        (response: HttpResponse<SelecionarExtratoEstoqueDetalhe[]>) => {

          this.isLoading = false;
          this.isTableLoading = false;
          this.extratos.data = response.body;
          if (response.body.length > 0) {
            this.paging.length = response.body[0].totalCount;
          }

          if (this.filtroExtrato.devolucao === true) {
            this.displayedColumns
              = ['status', 'data', 'modelo', 'sequencia', 'codigoBarra', 'usuario'];
          }
          if (this.filtroExtrato.status === '3, 6') {
            this.displayedColumns
              = ['status', 'data', 'modelo', 'sequencia', 'codigoBarra', 'usuario', 'origem', 'destino', 'usuarioDev'];
          }
          if (this.filtroExtrato.status === '2') {
            this.displayedColumns
              = ['status', 'data', 'modelo', 'sequencia', 'codigoBarra', 'usuario', 'origem'];
          }
        });
    this.isLoading = false;
    this.isTableLoading = false;
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.selecionarExtratoEstoqueDetalhe();
  }

  totalExtrato() {
    return Object.keys(this.extratos.data).length;
  }
}
